const createImpressionEvent = (sectionName, details) => {
  return {
    category: sectionName,
    action: `Viewed`,
    label: details,
    nonInteraction: true
  };
};

const createClickEvent = (sectionName, details) => {
  return {
    category: sectionName,
    action: 'Clicked', 
    label: details
  }
}

export { createImpressionEvent, createClickEvent };